const dataNew = [
  {
    date: "2022-03-01 01:15:05.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:06.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:07.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:08.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:09.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:0.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:11.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:12.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:13.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:14.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
    "FCAN2_TLAX_HEV_2nd_F_ALL_0.00::ACC_30C::ACC_INFO_IND_RADAR": 0,
    "FCAN2_TLAX_HEV_2nd_F_ALL_0.00::ACC_30C::ACC_INFO_IND_DISTANCE": 1,
    accmBrkAdaptiveAsilBFlag: 34.99524266666666,
    accmStandstillWarnAsilBFlag: 135.87074266666664,
    accmEbaAsilBFlag: 164.0,
  },
  {
    date: "2022-03-01 01:15:15.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:16.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:17.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:18.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:19.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:20.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:21.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:22.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:23.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:24.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:25.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:26.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:27.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:28.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:29.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:30.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:31.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:32.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:33.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:34.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:35.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:36.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:37.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:38.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:39.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:40.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:41.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:42.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:43.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:44.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:45.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:46.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:47.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:48.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:49.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:50.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:51.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:52.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:53.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:54.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:55.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:56.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:57.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:58.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:15:59.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:00.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:01.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:02.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:03.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:04.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:05.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:06.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:07.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:08.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:09.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:0.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:11.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:12.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:13.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:14.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:15.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:16.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:17.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:18.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
    "FCAN2_TLAX_HEV_2nd_F_ALL_0.00::ACC_30C::ACC_INFO_IND_RADAR": 0,
    "FCAN2_TLAX_HEV_2nd_F_ALL_0.00::ACC_30C::ACC_INFO_IND_DISTANCE": 1,
    accmBrkAdaptiveAsilBFlag: 34.99526266666667,
    accmStandstillWarnAsilBFlag: 135.87077583333334,
    accmEbaAsilBFlag: 161.89999389648438,
  },
  {
    date: "2022-03-01 01:16:19.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:20.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:21.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:22.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:23.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:24.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:25.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:26.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:27.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:28.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:29.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:30.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:31.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:32.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:33.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:34.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:35.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:36.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:37.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:38.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:39.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:40.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
    accmBrkAdaptiveAsilBFlag: 0,
    accmStandstillWarnAsilBFlag: 0,
    accmEbaAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:41.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:42.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:43.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:44.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:45.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:46.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:47.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:48.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:49.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:50.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:51.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:52.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:53.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:54.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:55.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:56.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:57.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:58.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:16:59.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:00.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:01.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:02.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:03.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:04.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:05.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:06.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:07.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:08.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:09.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:0.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:11.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:12.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:13.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:14.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:15.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:16.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:17.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:18.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:19.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:20.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:21.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:22.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:23.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:24.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:25.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:26.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:27.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:28.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:29.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:30.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:31.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:32.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:33.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:34.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:35.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:36.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:37.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:38.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:39.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:40.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:41.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:42.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:43.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:44.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:45.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:46.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:47.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:48.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:49.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:50.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:17:51.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },

  {
    date: "2022-03-01 01:29:47.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:29:48.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:29:49.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:29:50.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:29:51.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:29:52.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:29:53.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:29:54.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:29:55.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:29:56.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:29:57.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:29:58.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:29:59.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:30:00.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:30:01.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:30:02.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
  {
    date: "2022-03-01 01:30:03.000",
    accmIndiWarnAsilDFlag: 0,
    accmBuzzerWarnAsilDFlag: 0,
    accmHuwWarnAsilDFlag: 0,
    accmPrefillAsilDFlag: 0,
    accmBrkLvlAsilDFlag: 0,
    accmBrkAdaptiveAsilDFlag: 0,
    accmStandstillWarnAsilDFlag: 0,
    accmEbaAsilDFlag: 0,
    accmIndiWarnAsilBFlag: 0,
    accmBuzzerWarnAsilBFlag: 1,
    accmHuwWarnAsilBFlag: 0,
    accmPrefillAsilBFlag: 0,
    accmBrkLvlAsilBFlag: 0,
  },
];
export default dataNew;
